import moment from 'moment-timezone';
import pluralize from 'pluralize';
import BaseDataProcessor from './baseDataProcessor';

export default class PointsEarnedDataProcessor extends BaseDataProcessor {
  constructor(apiStatisticsData, interval) {
    super();

    this.apiStatisticsData = apiStatisticsData;
    this.interval = interval;
  }

  get apiData() {
    return this.apiStatisticsData;
  }

  get data() {
    if (this.apiStatisticsData) {
      const { totalPointsEarned, delta } = this.apiStatisticsData;

      return [{ primaryText: totalPointsEarned, secondaryText: 'seeds' }, this.deltaItem(delta)].filter(item => item);
    } else {
      return [];
    }
  }

  get chartData() {
    if (this.apiStatisticsData) {
      const { distribution } = this.apiStatisticsData;
      const currentDate = moment(Date.now()).tz('UTC');

      return distribution.map((item) => this.mapDataForChart(item, currentDate));
    } else {
      return [];
    }
  }

  mapDataForChart(item, currentDate) {
    const isBeforeToday = moment.unix(item.intervalStart).isSameOrBefore(currentDate);
    return { x: this.xValue(moment.unix(item.intervalStart)), y: isBeforeToday ? item.totalPointsEarned : null };
  }

  get pointTooltip() {
    if(this.interval === 'all time') {
      return (datum) => `${datum.x}\n${pluralize('seed', datum.y || 0, true)}`;
    } else {
      return (datum) => pluralize('seed', datum.y || 0, true);
    }
  }

  deltaItem(delta) {
    if (this.apiStatisticsData) {
      if(this.interval !== 'all time' ) {
        return {
          primaryText: this.decorateDeltaValue(delta, BaseDataProcessor.SIGN_TYPE_ARROW),
          secondaryText: this.decorateDeltaText(delta, this.interval)
        }
      } else {
        return null;
      }
    } else {
      return {};
    }
  }

  xValue(value) {
    if(this.interval === 'all time' ) {
      return value.format('MMM DD');
    } else {
      return value.format('ddd')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/statistics/common/dataProcessors/pointsEarnedDataProcessor.js